import styled from 'styled-components'
import { margin } from '@styled-system/space'
import { themeGet } from '@styled-system/theme-get'

import eyeGlyph from 'iconoir/icons/eye-empty.svg'
import eyeOffGlyph from 'iconoir/icons/eye-off.svg'
import mailGlyph from 'iconoir/icons/mail.svg'

import { logoExtendedGlyph } from 'Assets/Svg'
import linesGlyph from 'Assets/Svg/lines.svg'

import { Link } from 'Components/UI'

export const Container = styled.div.attrs({
  as: 'section',
})`
  display: flex;
  justify-content: flex-end;
  width: 100vw;
  height: 100vh;
  background-color: ${themeGet('colors.bg.secondary')};
  overflow-y: auto;
`

export const Info = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 41%;
  padding: 42px;
  overflow: hidden;
`

export const Name = styled.div`
  height: 30px;
  font-size: 24px;
  line-height: normal;
  color: ${themeGet('colors.bg.primary')};

  ${margin}
`

export const Slogan = styled.div`
  z-index: 1;
  position: relative;
  color: ${themeGet('colors.white')};
  font-size: 50px;
  line-height: 68px;
  font-weight: ${themeGet('fontWeights.3')};
  text-transform: uppercase;
  max-width: 520px;
`

export const Text = styled.div`
  max-width: 420px;
  font-size: 14px;
  color: ${themeGet('colors.font.primary')};
  flex-shrink: 0;

  ${margin};
`

export const Lines = styled(linesGlyph)`
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  opacity: 0.5;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: center;
  width: 59%;
  padding: ${themeGet('space.4')}px ${themeGet('space.6')}px;
  background-color: ${themeGet('colors.bg.primary')};
`

export const LogoExtendedIcon = styled(logoExtendedGlyph)``

export const Card = styled.div`
  width: 600px;
  padding: 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  border-radius: 12px;
  background: white;
`

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`

export const FormTitle = styled.h3`
  font-size: 24px;
  font-style: normal;
  font-weight: ${themeGet('fontWeights.2')};
  line-height: 32px;
  color: ${themeGet('colors.font.primary')};
  margin: 0;
`

export const MailIcon = styled(mailGlyph)`
  margin-left: 12px;
`

export const IconButton = styled.button`
  cursor: pointer;
  background: transparent;
  margin-right: 12px;
  border: 0;
  display: flex;
  align-items: center;
`

export const EyeIcon = styled(eyeGlyph)``

export const EyeOffIcon = styled(eyeOffGlyph)``

export const ForgotPasswordLink = styled(Link)`
  font-size: ${themeGet('fontSizes.0')}px;
  font-style: normal;
  font-weight: ${themeGet('fontWeights.2')};
`
